import IQuestion from "./interfaces/IQuestion";
import publiconboarding from "./publiconboarding";

interface IForms {
  [id: string]: (data: any) => IQuestion[];
}

const forms: IForms = {
  publiconboarding,
};

export default forms;
